import { ProfileState } from '@pages/profile/store/state/profile.state';
import { TimeZonesState } from '@pages/profile/store/state/time-zones.state';

export const profileState = [ProfileState, TimeZonesState];
